export const formSubmmitMapper = (data) => ({
  kode_kelompok_anggaran: data?.kodeKelompok,
  id_sub_kelompok_anggaran: data?.idSubKelompok,
  nama_sub_kelompok_anggaran: data?.namaSubKelompok,
  id_kelompok_anggaran: data?.idKelompok,
  keterangan: data?.keterangan,
});
